export interface IOnProcessingAllTasks {
    active: boolean;
    message: string;
}

export interface IOnProcessing {
    active: boolean;
    id: number[];
}

export const ON_PROCESSING_ALL_TASKS: IOnProcessingAllTasks = {
    active: false,
    message: null
};

export const ON_PROCESSING: IOnProcessing = {
    active: false,
    id: []
};